import { render, staticRenderFns } from "./SchoolConfiguration.vue?vue&type=template&id=0a036583&scoped=true"
import script from "./SchoolConfiguration.vue?vue&type=script&lang=js"
export * from "./SchoolConfiguration.vue?vue&type=script&lang=js"
import style0 from "./SchoolConfiguration.vue?vue&type=style&index=0&id=0a036583&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a036583",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a036583')) {
      api.createRecord('0a036583', component.options)
    } else {
      api.reload('0a036583', component.options)
    }
    module.hot.accept("./SchoolConfiguration.vue?vue&type=template&id=0a036583&scoped=true", function () {
      api.rerender('0a036583', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/SchoolConfiguration.vue"
export default component.exports